<template>
<div class="habit-card-sub-body d-flex mx-auto" >
        <div class="card-body">
            <div class="col-12 text-center bg-secondary">
                <h2 >Lesson Management Dashboard</h2>
                <div class="bg-warning my-2" style="font-size:.6em;">Recommended: Create all the images from a Course/Book/Chapter before editing/copying into TinyMCE<br/>
                        so that image-creation is available on the fly.</div>
            </div>
            <div class="row">
                <div class="color-palette-set bordered m-2 p-4">
                    <div class="color-palette-set  bordered  m-2 p-4">
                        <div class="bg-primary color-palette px-1"><span>Manage Lessons for Course:  </span> <i class="far fa-calendar-alt"></i></div>
                        <div v-if="allCoursesData.length>0" class="m-2">
                            <select @change="setCourseAssets()" v-model="selcourse_id">
                                <option value="">Select a Course</option>
                                <option v-for="xcourse in allCoursesData" :value="xcourse.id" :key="xcourse.id">{{xcourse.name}}: ({{xcourse.byline}})</option>
                            </select>
                        </div>
                    </div>

                    <div id="displayLessonCategories" v-if="courseLessonCats.length>0" style="max-width:100%;">
                        <h2 class="bg-warning text-center" v-html="'Course: ' + selectedCourseData.name"/>
                        <div class="bg-dark"><h4 class="text-center">Course Categories:</h4></div>
                        <table class="table table-striped">
                            <thead><tr><th>Name:</th><th>By-line</th><th>Order</th><th>Action</th><th class="text-center">Lessons:</th></tr></thead>
                            <tbody>
                            <tr v-for="lessoncat in courseLessonCats" :key="lessoncat.id">
                                <td>{{lessoncat.name}}</td><td>{{lessoncat.byline}}</td><td>{{lessoncat.order_num}}</td>
                                <td><i title="Create Lesson" @click="createLesson(lessoncat.id)" class="fas fa-pen text-primary"></i></td>
                            <td><table class="table table-dark table-striped" v-if="getLessonsForCat(lessoncat.id).length > 0">

                                <tr v-for="lesson in getLessonsForCat(lessoncat.id)" :key="lesson.id">
                                <td>{{lesson.name}}</td><td>{{lesson.byline}}</td><td>{{lesson.order_num}}</td>
                                <td><i title="Edit Lesson" @click="editLesson(lesson.id)" class="fas fa-pen text-primary"></i>
                                    <i title="Delete Lesson" @click="doubleConfirmDelete(lesson.id)" class="fas fa-trash text-danger"></i>
                                </td>
                            </tr>

                            </table></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                </div>
            </div>
          </div>

</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../event-bus';
import Editor from '@tinymce/tinymce-vue';


import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
        lessonInput: Editor,

     },
    name: "LessonManage",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            lessondata:{},
            allCoursesData:[],
            allLessonsData:[],
            selcourse_id:'',
            courseLessonCats:[],
            selectedCourseData:[],
        }
    },

    props: {
        user:'',
        templates:[],
        apikey:'',
        courses:'',
        lessons:'',
        lessoncatid : '',

    },
    mounted() {
        // console.log("ApiKey: " + this.apikey);
        this.allCoursesData = JSON.parse(this.courses);
        this.allLessonsData = JSON.parse(this.lessons);
        this.userinfo = JSON.parse(this.user);
        EventBus.$on('refreshLessonParent', (data) => {
            document.location.reload();
        });
        if(this.lessoncat_id) {
            this.createLesson(this.lessoncatid);
        }
    },


    methods: {
        getLessonsForCat(lessoncatid) {
            var lessons = [];
            [...this.allLessonsData].forEach(lesson=>{
                if(lesson.lesson_category_id == lessoncatid) lessons.push(lesson);
            });
            return lessons;

        },
        createLesson(lessoncatID) {
            EventBus.$emit('showNewLessonModal', {lessoncat_id: lessoncatID});
        },

        cancel() {
            console.log("Cancel close LessonManage");
            window.location.replace('/edu/admin/courses');
        },
        getLesson(lesson_id) {
             console.log("Looking for lesson with id " + lesson_id);
            var retVal = '';
            [...this.allLessonsData].forEach((lesson) =>{
                if(lesson.id == lesson_id) {
                    // console.log("Found lesson...");
                    retVal =  lesson;
                }
            });
            return retVal;
        },

    deleteLesson(lessonID) {
            axios.put('/edu/lesson/' + lessonID + '/delete')
            .then(res => {
                this.loading = false;
                this.success = true;
                // this.message = res.data.message;
                // this.updateToast(this.message, 4000);
                // console.error(res.data.message);
                this.allLessonsData = JSON.parse(JSON.stringify(res.data.lessons));
                this.$forceUpdate();
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                // location.reload();
            });
        },


        retrieveCourseLessonCats() {
            axios.get('/edu/course/lessoncats/' + this.selcourse_id)
            .then(res => {
                this.loading = false;
                this.success = true;
                // this.message = res.data.message;
                // this.updateToast(this.message, 4000);
                // console.error(res.data.message);
                this.courseLessonCats = JSON.parse(JSON.stringify(res.data.lessoncats));
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                // location.reload();
            });
        },

        setCourseAssets() {
            //retrieve the selected course's lesson_categories
           this.retrieveCourseLessonCats();
           this.getSelectedCourseInfo();
        },
        createNewLesson() {
            console.error(" lessonsmanage::cr new lesson.");
            var payload = {};
            EventBus.$emit('showNewLessonModal');
        },
        editLesson(lesson_id) {
            // var payload = {'course':  this.getLessonData(this.selcourse_id )};
            var payload = {'lessonid':  lesson_id, 'lessondata': this.getLesson(lesson_id), 'lessoncat_id': this.lessoncat_id};
            EventBus.$emit('editLessonModal', payload);
        },


        getCourseData(course_id) {
            //  console.error("looing for : " + course_id);
            var retVal = '';
            [...this.allCoursesData].forEach(course=> {
                if(course.id == course_id) {
                    // console.error("Found course...." + course.id);
                     retVal =  course;
                }
            });
            return retVal;
        },
        getSelectedCourseInfo() {
            if(this.selcourse_id != '') {
                var course = this.getCourseData(this.selcourse_id );
                this.selectedCourseData = course;
                return course.name + " <small>( " + course.byline + " )</small>";
            } else {
                return '';
            }
        },

        doubleConfirmDelete(lessonID) {
            Swal.fire({
            title: 'Do you Really want to delete the Lesson?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Delete',
            denyButtonText: `Don't delete`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                this.deleteLesson(lessonID);
                Swal.fire('Deleted!', '', 'success')
            } else if (result.isDenied) {
                Swal.fire('Lesson not deleted', '', 'info')
            }
            });
        },

        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}
</style>
